import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'uniqueByProperty' })
export class UniqueByPropertyPipe implements PipeTransform {
  transform<T>(array: T[], property: string): T[] {
    return [...new Map(array.map((item) => [item[property], item])).values()];
  }
}
